
import { useEffect, useState } from "react";
import { user } from "../features/user/selectors";
import { useSelector } from "react-redux";
import Logo from "./Logo";

const AorLogo = ({ displayPrefs }: { displayPrefs: string }) => {
	const [aorLogo, setAorLogo] = useState<any>();
	const userState = useSelector(user);
	const logoUrl = userState?.profile?.aor?.logoUrl ?? false;

	const checkIfImageExists = (url: string, callback: (exists: boolean) => void) => {
		const img = new Image();
		img.src = url;

		if (img.complete) {
			callback(true);
		} else {
			img.onload = () => {
				callback(true);
			};

			img.onerror = () => {
				callback(false);
			};
		}
	};

	useEffect(() => {
		if (logoUrl) {
			// Make sure the logoUrl image exists - fallback to CRMLS logo if not
			checkIfImageExists(logoUrl, (exists) => {
				if (exists) {
					setAorLogo(<img src={logoUrl} alt={userState?.profile?.aor?.name ?? "AOR Logo"} />);
				}
			});
		}
	}, [userState, logoUrl])
	

	return aorLogo ?? <Logo displayPrefs={displayPrefs} showVersion={false} />;
};

export default AorLogo;
